import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from '../hooks/useTranslation';

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer
      style={{
        marginTop: '4rem',
        padding: '2rem 0',
        borderTop: '1px solid rgba(0, 245, 255, 0.2)',
        textAlign: 'center'
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <p
          title="LinkedIn"
          style={{
            fontSize: '0.95rem',
            color: 'rgba(255, 255, 255, 0.7)',
            fontFamily: 'var(--font-body)',
            margin: 0,
            lineHeight: '1.6'
          }}
        >
          {t('footer.developedBy')}{' '}
          <motion.a
            href="https://linkedin.com/in/daniel-marnet"
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.05 }}
            style={{
              color: 'var(--accent)',
              textDecoration: 'none',
              fontWeight: '600',
              transition: 'all 0.3s',
              display: 'inline-block'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.textShadow = '0 0 10px var(--accent)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.textShadow = 'none';
            }}
          >
            Daniel Marnet
          </motion.a>
        </p>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.6 }}
          style={{
            marginTop: '0.5rem',
            fontSize: '0.85rem',
            color: 'rgba(255, 255, 255, 0.5)'
          }}
        >
          © {new Date().getFullYear()} - {t('footer.rights')}
        </motion.div>
      </motion.div>
    </footer>
  );
}

